import { cn } from "@bidbattles/bloks/lib/ui";

function BannerCard({ className, ...props }: React.ComponentProps<"div">) {
	return (
		<div
			{...props}
			className={cn(
				"p-4 md:p-6 flex flex-col gap-2 rounded-lg border-b-4 border-[#FF7B3C] bg-[rgba(255,123,60,0.10)]",
				className,
			)}
		/>
	);
}

function BannerTitle({ className, ...props }: React.ComponentProps<"p">) {
	return (
		<p
			{...props}
			className={cn("font-semibold flex gap-2 items-center", className)}
		/>
	);
}

export { BannerCard, BannerTitle };
